export enum UserTypes {
  admin = 'ADMIN',
  member = 'MEMBER',
}

export enum UserTypeLabels {
  admin = 'Admin',
  member = 'Member',
}
